export const px2rem = (pxValue, defaultValue = "initial") => {
    if (typeof pxValue !== "undefined") {
        return `${Number((pxValue / 16).toFixed(4))}rem`;
    }
    return defaultValue;
};
export const px2vw = (pxValue) => {
    return `${Number(((pxValue * 100) / 375).toFixed(4))}vw`;
};
export const MWEB_MINWIDTH = 750;
